import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EncryptServices, SendAdharOTPServices } from "../../services/index";
import { setAdharMsg } from "../../redux/slices/abhaSlice";
import AlreadyAbhaNumber from "../Already-abhanumber/already-abhanumber";
import { toast } from "react-toastify";
import { Eye, EyeOff } from "lucide-react";
import { setGlobalCurrentStep } from "../../redux/slices/abhaSlice";

/* ── Step marker images ── */
import step1Img from "../../assets/image/Group 110901.png";
import step2Img from "../../assets/image/Group 110902.png";
import step3Img from "../../assets/image/Group 110919.png";
import formBgImg from "../../assets/image/Group 2147206200.png";
import about from "../../assets/image/about_nha_pg_logo.png";
import { encryptData } from "../../services/aesUtils";

const STEPS = [
  {
    img: step1Img,
    title: "Verify Aadhaar Details",
    desc: "Enter your Aadhaar number and verify with OTP received on Aadhaar linked mobile number.",
  },
  {
    img: step2Img,
    title: "Link mobile number with ABHA",
    desc: "Enter your mobile number and verify with OTP to link with ABHA Address.",
  },
  {
    img: step3Img,
    title: "Create your ABHA",
    desc: "Create your ABHA Number with a unique ABHA address.",
  },
];

const SendAdharOTP = ({
  setAdharNumber,
  setSendOtpFunction,
  setPatient1,
  setCurrentStep
}) => {
  const [checkbox1Checked, setCheckbox1Checked] = useState(false);
  const [checkbox2Checked, setCheckbox2Checked] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [inputs, setInputs] = useState({
    input1: "",
    input2: "",
    input3: ""
  });
  const [aNumber, seaNumber] = useState("");
  const [alreadyAbhaNumber, setAlreadyAbhaNumber] = useState(false);
  const dispatch = useDispatch();
  const globalCurrentStep = useSelector(
    (state) => state.user.globalCurrentStep
  );

  const handleAlreadyAbhaNumber = () => {
    dispatch(setGlobalCurrentStep("AlreadyAbhaNumber"));
  };

  const moveToNextInput = (nextInputId) => {
    const currentInput = document.activeElement;
    if (currentInput.value.length === 4) {
      document.getElementById(nextInputId).focus();
    }
  };

  const handleBackspace = (event, prevInputId) => {
    const currentInput = document.activeElement;
    if (currentInput.value === "" && event.key === "Backspace") {
      document.getElementById(prevInputId).focus();
    }
  };

  const aadharNumber = aNumber.length > 9;

  const handleInputChange = (event, inputId) => {
    let { value } = event.target;
    value = value.replace(/\D/g, "");
    setInputs((prevState) => {
      const updatedInputs = { ...prevState, [inputId]: value };
      const aadharinputNumber = `${updatedInputs.input1 || ""}${updatedInputs.input2 || ""}${updatedInputs.input3 || ""}`;
      seaNumber(aadharinputNumber);
      return updatedInputs;
    });
  };

  const handleSubmit =async (e) => {
    e.preventDefault();
    const adharNumber = `${inputs.input1}${inputs.input2}${inputs.input3}`;
    localStorage.setItem("lastAadharnumber", inputs.input3);
    if (adharNumber.length === 12) {
      if (adharNumber) {
        // console.log(adharNumber, "Adhar Number");
              const encryptedAadhar=await encryptData(adharNumber);
              // console.log(encryptedAadhar,'5454');
              
              // const eAadhar = await EncryptServices({ headers: {}, body: { data: adharNumber } });
        SendAdharOtp(encryptedAadhar);
      } else {
        alert("Please enter a valid 4-digit OTP.");
      }
    }
  };

  const SendAdharOtp = async (adharNumber) => {
    try {
      const body = { aadhaarNumber: adharNumber };
      localStorage.setItem("aadhaarNumber", adharNumber);
      const response = await SendAdharOTPServices({ body });
      if (response.success === false) {
        if (response?.data?.loginId) {
          toast.error("Aadhaar number not registered");
        }
        if (response?.data?.error?.message.includes(":")) {
          const errorMessage = response.data?.error?.message.split(":");
          toast.error(errorMessage[2] || response?.message);
        }
      }
      if (response.status) {
        setAdharNumber(true);
        const txnId = response.result.txnId;
        const msg = response?.result?.message;
        dispatch(setAdharMsg(msg));
        setCurrentStep("VerifyAdhaOtp");
        localStorage.setItem("txnId", txnId);
        const body = { aadhaarNumber: adharNumber };
        setAdharNumber(body);
      }
    } catch (error) {
      console.error("Error while getting token:", error);
      toast.error(error.message);
    }
  };

  return (
    <>
      <section className="lmop-section">
        <div className="container">
          <h2 className="lmop-left-title">Create ABHA Number in 3 Steps</h2>
          <p className="lmop-left-desc">
            Create ABHA and store all your medical records in one place.
            Take part in the{" "}
            <span className="highlight">Ayushman Bharat Digital Mission (ABDM)</span>{" "}
            and get started on your digital health journey.
          </p>

          <div className="row align-items-start g-4 g-lg-5">

            {/* ── LEFT: 3 Steps ── */}
            <div className="col-12 col-md-6">
              <div className="lmop-steps">
                {STEPS.map((step, idx) => (
                  <React.Fragment key={idx}>
                    <div className="lmop-step-item">
                      <div className="lmop-step-marker">
                        <img src={step.img} alt={`Step ${idx + 1}`} />
                      </div>
                      <div className="lmop-step-body">
                        <h4>{step.title}</h4>
                        <p>{step.desc}</p>
                      </div>
                    </div>
                    {idx < STEPS.length - 1 && <div className="lmop-step-line" />}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* ── RIGHT: Form Card ── */}
            {globalCurrentStep === "AlreadyAbhaNumber" ? (
              <AlreadyAbhaNumber />
            ) : (
              <div className="col-12 col-md-6">
                <div
                  className="lmop-card-wrap"
                  style={{
                    backgroundImage: `url(${formBgImg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="lmop-card-inner">
                    <h3 className="lmop-card-title">Enter Aadhaar Details to Create/Link ABHA</h3>

                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <p className="lmop-card-subtitle mb-0">
                        OTP Will Be Sent to The Mobile Number Linked
                      </p>
                      {showPassword ? (
                        <Eye
                          className="eye-icon"
                          style={{ cursor: "pointer", color: "#555" }}
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      ) : (
                        <EyeOff
                          className="eye-icon"
                          style={{ cursor: "pointer", color: "#555" }}
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      )}
                    </div>

                  <form onSubmit={handleSubmit} className="pt-2" autoComplete="off">

  {/* Aadhaar 3-part input */}
  <div className="aadhar-input d-flex justify-content-center pt-1 gap-3">
    <input
      className="adhar-input text-center lmop-mobile-input"
      type={showPassword ? "text" : "password"}
      maxLength="4"
      pattern="[0-9]{4}"
      title="Please enter 4 digits"
      placeholder="XXXX"
      id="input1"
      autoComplete="off"
      onInput={() => moveToNextInput("input2")}
      value={inputs.input1}
      onChange={(event) => handleInputChange(event, "input1")}
      required
      inputMode="numeric"
      style={{ width: "80px", textAlign: "center" }}
    />
    <input
      className="adhar-input text-center lmop-mobile-input"
      type={showPassword ? "text" : "password"}
      maxLength="4"
      pattern="[0-9]{4}"
      title="Please enter 4 digits"
      placeholder="XXXX"
      id="input2"
      autoComplete="off"
      onInput={() => moveToNextInput("input3")}
      onKeyDown={(event) => handleBackspace(event, "input1")}
      value={inputs.input2}
      onChange={(event) => handleInputChange(event, "input2")}
      required
      inputMode="numeric"
      style={{ width: "80px", textAlign: "center" }}
    />
    <input
      className="adhar-input text-center lmop-mobile-input"
      type={showPassword ? "text" : "password"}
      maxLength="4"
      pattern="[0-9]{4}"
      title="Please enter 4 digits"
      placeholder="XXXX"
      id="input3"
      autoComplete="off"
      onKeyDown={(event) => handleBackspace(event, "input2")}
      value={inputs.input3}
      onChange={(event) => handleInputChange(event, "input3")}
      required
      inputMode="numeric"
      style={{ width: "80px", textAlign: "center" }}
    />
  </div>

  {/* Checkboxes */}
  <div className="d-flex mt-3">
    <input
      type="checkbox"
      className="form-check-input checkbox-color my-2"
      id="flexCheckDefault"
      checked={checkbox1Checked}
      autoComplete="off"
      onChange={() => setCheckbox1Checked(!checkbox1Checked)}
    />
    <label className="form-check-label ps-2 my-2" htmlFor="flexCheckDefault">
      I agree to{" "}
      <a className="resend-otp" href="https://abym.in/term-of-conditions" target="_blank">
        Terms & Conditions
      </a>{" "}
      and{" "}
      <a className="resend-otp" href="https://abym.in/privacy-policy" target="_blank">
        Privacy Policy
      </a>{" "}
      AbyM to Create/Link my ABHA.
    </label>
  </div>

  <div className="d-flex">
    <input
      type="checkbox"
      className="form-check-input checkbox-click"
      id="flexCheckDefaultNHA"
      checked={checkbox2Checked}
      autoComplete="off"
      onChange={() => setCheckbox2Checked(!checkbox2Checked)}
    />
    <label className="form-check-NHA ps-2 mb-2" htmlFor="flexCheckDefaultNHA">
      I agree to{" "}
      <a className="resend-otp" href="/terms-condition" target="_blank">
        Terms & Conditions
      </a>{" "}
      approved by the NHA
    </label>
  </div>

  <button
    type="submit"
    className={`lmop-continue-btn ${!aadharNumber || !checkbox1Checked || !checkbox2Checked ? "bg-disable" : ""}`}
    disabled={!aadharNumber || !checkbox1Checked || !checkbox2Checked}
  >
    Continue
  </button>

  {/* ── Already ABHA button ── */}
  <p style={{ textAlign: "center", marginTop: "14px", marginBottom: "0" }}>
    <button
      type="button"
      onClick={handleAlreadyAbhaNumber}
      style={{
        background: "none",
        border: "none",
        color: "#1a7fff",
        fontWeight: "600",
        fontSize: "0.88rem",
        cursor: "pointer",
        fontFamily: "Manrope, sans-serif",
        textDecoration: "underline",
        padding: 0,
      }}
    >
      I already have Abha Number / ABHA
    </button>
  </p>

</form>

                    <div className="lmop-nha-row">
                      <span className="lmop-nha-label">Approved by NHA</span>
                      <img src={about} alt="NHA Logo" className="lmop-nha-logo" />
                    </div>

                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </section>
    </>
  );
};

export default SendAdharOTP;